import { type ReactNode } from 'react';
import { type ThemeTypes } from 'types/Theme.namespace';

export const ListInlineSeparator = {
  BULLET: 'BULLET',
  LINE: 'LINE',
} as const;

type ListType = 'ul' | 'ol';
export type ListInlineSeparators =
  (typeof ListInlineSeparator)[keyof typeof ListInlineSeparator];

export type ListItemProps = {
  separator?: ListInlineSeparators;
  separatorColour: ThemeTypes.Colors;
  fontSize: ThemeTypes.FontSize;
};

export type ListInlineProps = {
  /**
   * If only one child is passed, we add it to an array and map it to a list item.
   * Otherwise, each child is mapped as a list item.
   */
  children: ReactNode | Array<ReactNode>;
  as?: ListType;
  keyName: string;
} & Partial<ListItemProps>;
